import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const Strike = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const strike = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'strike'));

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const handleStrike = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Strike changed', value?.toString() ?? 'null');

    return check({
      strike: isDefined(value) ? value : null,
    });
  };

  return (
    <FormField formattedMessageId="forwardAccumulator.form.strike">
      <TradeCaptureValidationWrapper validation={validation?.strike}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={strike}
          maxDecimals={9}
          allowNegative={false}
          onChange={handleStrike}
          size="sm"
          data-e2e="strike"
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default Strike;
